import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  // Derive a stable testid from className (desktop/mobile) so tests can pick either explicitly
  const testid = className.includes("mobile") ? "theme-toggle-mobile" : "theme-toggle-desktop";

  if (!mounted) {
    return (
      <button
        className={`w-9 h-9 rounded-full border border-slate-200 dark:border-slate-700 ${className}`}
        aria-label="Toggle theme"
        data-testid={testid}
      />
    );
  }

  const isDark = theme === "dark";
  return (
    <button
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={`w-9 h-9 rounded-full border border-slate-200 dark:border-slate-700 flex items-center justify-center bg-white dark:bg-slate-900 hover:border-blue-700 dark:hover:border-blue-400 transition-colors group ${className}`}
      aria-label="Toggle dark mode"
      data-testid={testid}
    >
      {isDark ? (
        <Sun className="w-4 h-4 text-amber-400 group-hover:rotate-45 transition-transform" />
      ) : (
        <Moon className="w-4 h-4 text-slate-700 group-hover:-rotate-12 transition-transform" />
      )}
    </button>
  );
}
